import { Component, type ErrorInfo, type ReactNode } from "react";
import { Button } from "@/components/ui/Button";
import { CyberPanel } from "@/components/ui/CyberPanel";

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  error: Error | null;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Unhandled render error", error, info);
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <main className="cyber-grid grid min-h-screen place-items-center bg-ink px-4 text-content-primary">
        <CyberPanel className="max-w-xl text-center" role="alert">
          <p className="mb-3 text-sm font-semibold uppercase tracking-[0.28em] text-red-100">Application Error</p>
          <h1 className="font-display text-4xl font-bold uppercase text-white">Something broke</h1>
          <p className="mt-4 text-content-secondary">
            The page hit an unexpected error. Reload the app, or return home and try again.
          </p>
          <div className="mt-6 flex flex-col justify-center gap-3 sm:flex-row">
            <Button type="button" onClick={() => window.location.reload()}>
              Reload
            </Button>
            <Button asChild variant="secondary">
              <a href="/">Return Home</a>
            </Button>
          </div>
        </CyberPanel>
      </main>
    );
  }
}
